<template>
  <div>
    <div class="nav" v-if="topicData" v-html="topicData.topic.stem.replace(/\n/g, '<br>')">
    </div>
    <div class="interval"></div>
    <div class="con">
      <div class="conNav">
        <div class="navIcon">
          <img src="../../assets/examinatSystem/cutIcon.png" alt="">
          <a>Cut</a>
        </div>
        <div class="navIcon">
          <img src="../../assets/examinatSystem/copyIcon.png" alt="">
          <a>Copy</a>
        </div>
        <div class="navIcon">
          <img src="../../assets/examinatSystem/paste.png" alt="">
          <a>Paste</a>
        </div>
        <div class="navIcon">
          <img src="../../assets/examinatSystem/UndoIcon.png" alt="">
          <a>Undo</a>
        </div>
        <div class="navIcon">
          <img src="../../assets/examinatSystem/redoIcon.png" alt="">
          <a>Redo</a>
        </div>
      </div>
      <textarea class="textAreas" v-model="textarea" cols="30"></textarea>
    </div>
  </div>
</template>

<script>
  import api from '@/api/dryRun.js'
  export default {
    data() {
      return {
        textarea: '',
        topicData: null, //题目数据
      }
    },
    watch: {
      textarea(val) {
        if (val === '') {
          sessionStorage.setItem('isAnswer', false)
        } else {
          sessionStorage.setItem('isAnswer', true)
          sessionStorage.setItem('answer', JSON.stringify([val]))
        }
      }
    },
    async created() {
      if (sessionStorage.getItem('examType') === '练习') {
        if (sessionStorage.getItem('isFirst') === 'true') {
          this.startExercise()
        } else {
          this.nextExerciseTopic()
        }
      } else {
        if (sessionStorage.getItem("review") === "true") {
          this.getMockexam();
        } else if (sessionStorage.getItem('isFirst') === 'true') {
          this.startAnswer()
        } else {
          let params = {
            id: sessionStorage.getItem('curId'),
            m_id: sessionStorage.getItem('m_id'),
          }
          const res = await api.next(params)
          console.log('新一题数据', res);
          if (res.data.code === 0) {
            this.topicData = res.data.data
            let nums = this.topicData.index
            const q_id = this.topicData.topic.id;
            if (this.topicData.sortlist) {
              for (const item of this.topicData.sortlist) {
                if (item.indexOf(q_id) > -1) {
                  nums = item.indexOf(q_id) + 1
                }
              }
            }
            sessionStorage.setItem('mark', this.topicData.mark);
            sessionStorage.setItem('q_id', q_id);
            sessionStorage.setItem('collect', this.topicData.topic.collect);
            sessionStorage.setItem('nums', nums);
            document.getElementById("i").innerHTML = sessionStorage.getItem("nums");
            sessionStorage.setItem('topicCount', this.topicData.topicCount);
            document.getElementById("count").innerHTML = sessionStorage.getItem("topicCount");
            sessionStorage.setItem('topicCType', this.topicData.topicCType);
            sessionStorage.setItem('choice', JSON.stringify(this.topicData.choice));
            this.$emit('changeReview')

          }
        }
      }
    },
    methods: {
      // 获取练习题数据
      async startExercise() {
        const startRes = await api.startExercise({
          m_id: sessionStorage.getItem('m_id')
        })
        console.log('练习题数据', startRes);
        if (startRes.data.code === 0) {
          this.topicData = startRes.data.data;
          sessionStorage.setItem('q_id', this.topicData.topic.id);
          sessionStorage.setItem('collect', this.topicData.topic.collect);
          sessionStorage.setItem('isFirst', false)
          sessionStorage.setItem('topicCount', this.topicData.topicCount);
          document.getElementById("count").innerHTML = sessionStorage.getItem("topicCount");
          sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
        } else {
          this.$message.error(startRes.data.msg);
        }
      },
      async nextExerciseTopic() {
        let params = {
          id: sessionStorage.getItem('curId'),
          m_id: sessionStorage.getItem('m_id')
        }
        const startRes = await api.nextExercise(params)
        console.log('下一道练习题', startRes);
        if (startRes.data.code === 0) {
          this.topicData = startRes.data.data;
          let nums = this.topicData.index
          const q_id = this.topicData.topic.id;
          if (this.topicData.sortlist) {
            for (const item of this.topicData.sortlist) {
              if (item.indexOf(q_id) > -1) {
                nums = item.indexOf(q_id) + 1
              }
            }
          }
          sessionStorage.setItem('q_id', q_id);
          sessionStorage.setItem('collect', this.topicData.topic.collect);
          sessionStorage.setItem('nums', nums);
          sessionStorage.setItem('isFirst', false)
          sessionStorage.setItem("choice", JSON.stringify(this.topicData.choice));
          sessionStorage.setItem("topicCount", this.topicData.topicCount);
          document.getElementById("count").innerHTML =
            sessionStorage.getItem("topicCount");
        } else {
          this.$message.error(startRes.data.msg);
        }
      },
    async getMockexam() {
      let startParams = {
        id: sessionStorage.getItem("curId"),
        m_id: sessionStorage.getItem("m_id"),
        q_id: sessionStorage.getItem("q_id"),
      };
        const startRes = await api.getMockexam(startParams)
        console.log('开始考试', startRes);
        console.log(startRes.data.data);
        if (startRes.data.code === 0) {
          this.topicData = startRes.data.data
          let nums = this.topicData.index
          const q_id = this.topicData.topic.id;
          if (this.topicData.sortlist) {
            for (const item of this.topicData.sortlist) {
              if (item.indexOf(q_id) > -1) {
                nums = item.indexOf(q_id) + 1
              }
            }
          }
          sessionStorage.setItem('q_id', q_id);
          sessionStorage.setItem('mark', this.topicData.mark);
          sessionStorage.setItem('collect', this.topicData.topic.collect);
          sessionStorage.setItem('nums', nums);
          sessionStorage.setItem('topicCount', this.topicData.topicCount);
          document.getElementById("count").innerHTML = sessionStorage.getItem("topicCount");
          sessionStorage.setItem('topicCType', this.topicData.topicCType);
          sessionStorage.setItem('choice', JSON.stringify(this.topicData.choice));
          sessionStorage.setItem('isFirst', false)
          if (this.topicData.answer !== "0") {
          this.answer = this.topicData.answer;
          sessionStorage.setItem(
            "answer",
            JSON.stringify([this.topicData.answer.toString()])
          );
          sessionStorage.setItem("isAnswer", true);
          this.$emit('changeReview')

        }
        }
      },
      async startAnswer() {
        let startParams = {
          m_id: sessionStorage.getItem('m_id'),
          // m_id:this.$route.params.id,
          id: this.$route.query.id
        }
        const startRes = await api.startMockExam(startParams)
        console.log('开始考试', startRes);
        console.log(startRes.data.data);
        if (startRes.data.code === 0) {
          this.topicData = startRes.data.data
          let nums = this.topicData.index
          const q_id = this.topicData.topic.id;
          if (this.topicData.sortlist) {
            for (const item of this.topicData.sortlist) {
              if (item.indexOf(q_id) > -1) {
                nums = item.indexOf(q_id) + 1
              }
            }
          }
          sessionStorage.setItem('q_id', q_id);
          sessionStorage.setItem('collect', this.topicData.topic.collect);
          sessionStorage.setItem('nums', nums);
          sessionStorage.setItem('topicCount', this.topicData.topicCount);
          document.getElementById("count").innerHTML = sessionStorage.getItem("topicCount");
          sessionStorage.setItem('topicCType', this.topicData.topicCType);
          sessionStorage.setItem('choice', JSON.stringify(this.topicData.choice));
          sessionStorage.setItem('isFirst', false)
        }
      }
    }
  };

</script>

<style scoped>
  @import '../../assets/css/systemRead.css';

</style>



// WEBPACK FOOTER //
// src/view/examinatSystem/systemRead.vue